// extracted by mini-css-extract-plugin
export var attachment = "_m7-a";
export var emailContainer = "_m7-4";
export var emailContentPaddedContainer = "_m7-b";
export var emailHeader = "_m7-6";
export var emailIframe = "_m7-3";
export var emailInfoIcon = "_m7-9";
export var emailShortenedSummary = "_m7-e";
export var infoDropdown = "_m7-0";
export var infoRowBoundedContent = "_m7-d";
export var internal = "_m7-5";
export var merchant = "_m7-8";
export var messageInputContainer = "_m7-h";
export var normal = "_m7-7";
export var replyCard = "_m7-f";
export var subtleButton = "_m7-1";
export var subtleButtonIconContainer = "_m7-2";
export var toggleViewRepliesButton = "_m7-c";
export var wrappingText = "_m7-g";